var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var utils = require('../../../utils/utils');
var HeroTextBlock = require('./layout/heroTextBlock.jsx');
var TreatmentNavList = require('./layout/treatmentNavList.jsx');
var FeaturedPlacement = require('./layout/featuredPlacement.jsx');
var ConditionNavList = require('./layout/condtionNavList.jsx');
var AppPromo = require('../../components/appPromo.jsx');
var ContentHeader = require('./layout/contentHeader.jsx');
var BackButton = require('../../components/backButton.jsx');

var Condition = createReactClass({
	mixins: [PureRenderMixin],

    componentDidMount: function() {
        this.props.fetchConditionsIfNeeded();
        this.props.fetchConditionIfNeeded(this.props.params.name);

        // if condition is provided by server rendering and has featuredPlacement, then init featuredPlacement
        if(this.props.condition.items[0] && this.props.condition.items[0].featuredPlacement && this.props.condition.items[0].featuredPlacement.webTag){
            this.fetchFeaturedPlacement(this.props.condition.items[0].featuredPlacement);
        }
    },

    componentWillUnmount: function() {
        this.clearStatesAsNeeded();
    },

    componentWillReceiveProps: function(nextProps) {
        if(nextProps.params.name !== this.props.params.name){
            this.clearStatesAsNeeded();
            this.props.fetchConditionIfNeeded(nextProps.params.name);
        }

        // when condition get updated
        if(nextProps.condition.items[0] && !this.props.condition.items[0]){
            if(nextProps.condition.items[0].featuredPlacement && nextProps.condition.items[0].featuredPlacement.webTag){
                // update featuredPlacement when the new condition has featuredPlacement
                this.fetchFeaturedPlacement(nextProps.condition.items[0].featuredPlacement);
            }else{
                // or clear previous featuredPlacement
                this.props.resetFeaturedPlacement();
            }
        }
    },

    fetchFeaturedPlacement: function(featuredPlacement){
        if(utils.isSmallScreen()){
            this.props.fetchFeaturedPlacement(featuredPlacement.responsiveTag);
        }else{
            this.props.fetchFeaturedPlacement(featuredPlacement.webTag);
        }
    },

    clearStatesAsNeeded: function(){
        // clear Redux store states
        this.props.resetCondition();
        this.props.resetFeaturedPlacement();
        this.props.resetSponsoredPlacement();
    },

    openSponsoredPlacementReveal: function(intervention){
        setTimeout(function(){ // this timeout is used to let that setting redux state takes effect
            if(this.props.generic_error){
                this.props.hideModal();
            }else{
                this.props.showModal('MODAL_TYPE_SPONSORED', {
                    title: intervention.commercialName || intervention.genericName,
                    placement: this.props.sponsoredPlacement
                });
            }
        }.bind(this));
    },

    handleSponsoredPlacementChange: function(intervention){
        this.props.resetSponsoredPlacement();

        // open the popup early for user feedback
        this.openSponsoredPlacementReveal(intervention);

        this.props.fetchSponsoredPlacement(utils.isSmallScreen() ? intervention.sponsoredPlacement.responsiveTag : intervention.sponsoredPlacement.webTag, function(){
            this.openSponsoredPlacementReveal(intervention);
        }.bind(this));
    },

    isSponsoredTreatment: function(treatment){
        return treatment.interventions[0].isSponsored;
    },

    // for treatment being valid, it must has one valid sponsored or non-sponsored intervention at least
    // "valid sponsored intervention" means that the condition result of `intervention.isSponsored && intervention.sponsoredPlacement.webTag` is TRUE
    isValidTreatment: function(treatment){
        var isValid = false;
        treatment.interventions.forEach(function(intervention){
            if(!intervention.isSponsored || intervention.sponsoredPlacement.webTag){
                isValid = true;
            }
        });

        return isValid;
    },

    hasDataLoaded: function(){
        return !!(Object.keys(this.props.condition.items[0] || {}).length && !this.props.condition.isFetching);
    },

    getContent: function(){
        var condition = this.props.condition.items[0] || {};
        var activeCondition = condition;

        var validTreatments = [];
        var sponsoredTreatments = [];
        var notSponsoredTreatments = [];
        var hasFeaturedPlacement = false;

        if(this.hasDataLoaded()) {
            validTreatments = condition.treatments.filter(function(treatment) {
                return this.isValidTreatment(treatment);
            }.bind(this));

            sponsoredTreatments = validTreatments.filter(function(treatment) {
                return this.isSponsoredTreatment(treatment);
            }.bind(this));

            notSponsoredTreatments = validTreatments.filter(function(treatment) {
                return !this.isSponsoredTreatment(treatment);
            }.bind(this));

            hasFeaturedPlacement = condition.featuredPlacement && condition.featuredPlacement.webTag;
        }

        var children = [
            <Helmet
                title={(condition.meta && condition.meta.title) || condition.title}
                meta={[{
                    name: 'description',
                    content: (condition.meta && condition.meta.description) || condition.description
                }]}
                key={0} />,
			<ContentHeader key="content-header" />,
            hasFeaturedPlacement ? (
                <div className="ad-banner-placeholder-wrapper" key={1}>
                    <div className="ad-banner-placeholder">
                        <div style={{paddingTop: this.props.featuredPlacement.height/this.props.featuredPlacement.width * 100 + '%'}}></div>
                    </div>
                </div>
            ) : null,
            <div className="main-wrapper row" key={2}>
                <div className="medium-5 large-4 column">
					<BackButton key="back-button" />
                    <ConditionNavList
                        className="condition-nav"
                        conditions={this.props.conditions}
                        activeCondition={activeCondition}
                        clickTracking={this.props.recordConditionClick} />
                </div>
                <div className="medium-7 large-8 column">
                    <div className="condition-information">
                        <div className="row">
                            <div className="column end">
                                {hasFeaturedPlacement &&
                                    <FeaturedPlacement placement={this.props.featuredPlacement} />
                                }                            
                                <HeroTextBlock
                                    title={condition.title}
                                    descriptions={[condition.popup]}
                                    size={'normal'}
                                    firstButton={condition.firstButton}
                                    clickTracking={this.props.recordTreatmentClick} />
                            </div>
                        </div>
                        <div className="treatment-information">
                            {sponsoredTreatments.length > 0 &&
                                <div className="sponsored-treatments">
                                    <TreatmentNavList
                                        treatments={sponsoredTreatments}
                                        clickTracking={this.props.recordTreatmentClick}
                                        onSponsoredPlacementChange={this.handleSponsoredPlacementChange} />
                                </div>
                            }
                            <div className="not-sponsored-treatments">
                                <TreatmentNavList
                                    treatments={notSponsoredTreatments}
                                    clickTracking={this.props.recordTreatmentClick}
                                    onSponsoredPlacementChange={this.handleSponsoredPlacementChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
			<div className="app-promo-wrapper" key={'app-promo-wrapper'}>
				<div className="row column">
					<AppPromo
						pageTitle={condition.title || 'Treatment Center detail page'}
						recordDownloadClick={this.props.recordDownloadClick} />
				</div>
			</div>
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return content;
    },

    render: function () {
        return (
            <div className="content">
                {this.getContent()}
            </div>
        );
    }
});

module.exports = Condition;



// WEBPACK FOOTER //
// ./src/common/routes/conditions/components/condition.jsx